import { Option } from '../interfaces/multiselect'

export const useFormatUniqueness = (options: Option[]): Option[] => {
  const purgeDuplicates = (options: Option[]) =>
    [...new Set(options.map((option: Option) => JSON.stringify(option)))].map((item) => JSON.parse(item))
  const uniqueOptions = purgeDuplicates(options)
  return uniqueOptions
}
